// File: src/components/ToolsModal.js
import React from 'react';
import { motion } from 'framer-motion';
import { formatDistanceToNow } from 'date-fns';
import ToolCard from './ToolCard';

const ToolsModal = ({ isOpen, history, onClose, onSearchAgain }) => {
  if (!isOpen || !history) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50 backdrop-blur-sm">
      <motion.div 
        className="bg-white rounded-xl shadow-lg max-w-4xl w-full max-h-[90vh] flex flex-col"
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.95 }}
        transition={{ duration: 0.2 }}
      >
        {/* Modal Header */}
        <div className="flex justify-between items-center p-6 border-b border-gray-100">
          <div>
            <h2 className="text-xl font-bold text-gray-900">Search Results</h2>
            <p className="text-sm text-gray-500 mt-1">
              <span className="font-medium">"{history.query}"</span> • 
              {' ' + formatDistanceToNow(new Date(history.timestamp), { addSuffix: true })}
            </p>
          </div>
          <button 
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 rounded-full p-2 hover:bg-gray-100 transition-colors"
            aria-label="Close modal"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
        
        {/* Modal Content */}
        <div className="overflow-y-auto p-6 flex-grow">
          {history.tools.length === 0 ? (
            <div className="flex flex-col items-center justify-center p-10 text-center">
              <svg className="w-16 h-16 text-gray-300 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
              <h3 className="text-lg font-medium text-gray-900 mb-1">No tools found</h3>
              <p className="text-gray-500">This search didn't return any tools.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {history.tools.map((tool, index) => (
                <ToolCard key={tool._id} tool={tool} />
              ))}
            </div>
          )}
        </div>
        
        {/* Modal Footer */}
        <div className="p-6 border-t border-gray-100 flex justify-between">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors">
            Close
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default ToolsModal;